import { useState, useEffect, useRef } from 'react';
import { DateRange, Range, RangeFocus } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

interface DateRangePickerProps {
    initialStartDate: Date;
    initialEndDate: Date;
    onChange: (startDate: Date, endDate: Date) => void;
}

const DateRangePickerComponent = ({
    initialStartDate,
    initialEndDate,
    onChange,
}: DateRangePickerProps) => {
    const [showRangePicker, setShowRangePicker] = useState(false);
    const [focusedRange, setFocusedRange] = useState<RangeFocus>([0, 0]);
    const inputRef = useRef<HTMLInputElement>(null);
    const pickerRef = useRef<HTMLDivElement>(null);

    const [range, setRange] = useState<Range[]>([
        {
            startDate: initialStartDate,
            endDate: initialEndDate,
            key: 'selection',
        },
    ]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                showRangePicker &&
                !pickerRef.current?.contains(event.target as Node) &&
                !inputRef.current?.contains(event.target as Node)
            ) {
                setShowRangePicker(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showRangePicker]);

    const formatDate = (date: Date): string => {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const formattedRange =
        range[0].startDate && range[0].endDate
            ? `${formatDate(range[0].startDate)} to ${formatDate(range[0].endDate)}`
            : '';


    return (
        <div style={{ position: 'relative' }}>
            <input
                ref={inputRef}
                type="text"
                readOnly
                value={formattedRange}
                placeholder="Select date range"
                className="form-control"
                onClick={() => setShowRangePicker(true)}
            />
            {showRangePicker && (
                <div ref={pickerRef} style={{ position: 'absolute', zIndex: 1000 }}>
                    <DateRange
                        editableDateInputs={true}
                        onChange={(item) => {
                            const newRange = [item.selection];
                            console.log("newRange", newRange[0].startDate, newRange[0].endDate);
                            setRange(newRange);
                            if (newRange[0].startDate && newRange[0].endDate) {
                                onChange(newRange[0].startDate, newRange[0].endDate);
                            }

                            if (focusedRange[1] === 0) {
                                setFocusedRange([0, 1]);
                            }
                        }}
                        months={2}
                        moveRangeOnFirstSelection={false}
                        ranges={range}
                        focusedRange={focusedRange}
                        onRangeFocusChange={setFocusedRange}
                        direction='horizontal'
                    />
                </div>
            )}
        </div>
    );
};

export default DateRangePickerComponent;